import { render } from "./book.view.vue?vue&type=template&id=0395526b&ts=true"
import script from "./book.view.vue?vue&type=script&lang=ts"
export * from "./book.view.vue?vue&type=script&lang=ts"

import "./book.view.vue?vue&type=style&index=0&id=0395526b&lang=scss"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__